import type { ReactNode } from "react";
import { cn } from "../lib/utils.js";

/**
 * "Nothing here yet", outside a table — one sentence, centered, in the same
 * vertical room TableEmpty reserves, so a list and a table that are both empty
 * leave the same hole in the page instead of two different ones.
 */
export function EmptyNote({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={cn("px-3 py-10 text-center text-sm text-muted-foreground", className)}>{children}</p>
  );
}
